import React from 'react';

/**
 * TableFelt Component
 * Renders the green felt background of the poker table
 */
export default function TableFelt({ width, height, children }) {
  return (
    <div
      style={{
        position: 'relative',
        width: `${width}px`,
        height: `${height}px`,
        background: 'linear-gradient(135deg, #059669 0%, #10b981 50%, #047857 100%)',
        borderRadius: '50%',
        border: '12px solid #047857',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3), inset 0 0 100px rgba(0, 0, 0, 0.1)',
        overflow: 'visible',
        zIndex: 1
      }}
    >
      {/* Felt texture overlay */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.05) 0%, transparent 50%),
            radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.03) 0%, transparent 50%),
            repeating-linear-gradient(
              45deg,
              transparent,
              transparent 2px,
              rgba(0, 0, 0, 0.02) 2px,
              rgba(0, 0, 0, 0.02) 4px
            )
          `,
          borderRadius: '50%',
          pointerEvents: 'none',
          zIndex: 1
        }}
      />
      {children}
    </div>
  );
}

